import { clear as idbClear, del, get, set } from 'idb-keyval';
import { EvictableDataStoreKey } from './storage.types';

const setItem = async <T>(
  key: EvictableDataStoreKey,
  value: T,
): Promise<void> => {
  return set(key, value);
};

const getItem = async <T>(
  key: EvictableDataStoreKey,
): Promise<T | undefined> => {
  return get(key);
};

const removeItem = async (key: EvictableDataStoreKey): Promise<void> => {
  return del(key);
};

const clear = async (): Promise<void> => {
  await idbClear();
};

export const EvictableDataStore = {
  clear,
  getItem,
  removeItem,
  setItem,
};
